import { GROUPID_REG } from "@views/thinking-layout-editor/constants";
import { creatorRefStore } from "@uiview/views/ProjectCanvas/store/CreatorRefStore";
import { getIt } from "@uikit/getIt";
import { CreatorNodesStore } from "@uiview/views/ProjectCanvas/store/CreatorNodesStore";
import { useHomePreviewMethods } from "@uiview/views/ProjectCanvas/useHomePreviewMethods";
import { PreviewAppStore } from "@uiview/views/ProjectCanvas/store/PreviewAppStore";

const useRunEdgeAddNodeToPreview = ({ handleInputField, setInputId }) => {
  const creatorNodesStore = getIt(CreatorNodesStore);
  const homePreviewMethods = useHomePreviewMethods();
  const previewAppStore = getIt(PreviewAppStore);

  //  第一次运行边，自动添加node到input和output
  function firstRunAddNodeToPreview({ sourceNode, outputNode }) {
    if (!creatorRefStore.firstRunEdgeRef.current) return;
    creatorRefStore.firstRunEdgeRef.current = false;
    previewAppStore.setShowPreviewPanel(true);
    if (Array.isArray(sourceNode)) {
      let inputIdArr = [];
      sourceNode.forEach(async item => {
        inputIdArr.push(item.id);
        await handleInputField(item);
      });
      setInputId(inputIdArr);
    } else {
      handleInputField(sourceNode);
      setInputId(sourceNode.id);
    }
    if (GROUPID_REG.test(outputNode?.id)) {
      homePreviewMethods.clickGroupToPreview(outputNode);
    } else {
      homePreviewMethods.addIndividual(outputNode);
    }
  }

  //  如果第一次运行边点的是runAll就执行这个
  const firstRunAllAddNodeToPreview = edgeId => {
    const nodes = creatorNodesStore.getNodes();
    const edgeNode = nodes.find(item => item.id === edgeId);
    const inputNodeIdArr = edgeNode?.data?.flows?.map(item => item.sourceNodeId);
    const outputNodeId = edgeNode?.data?.targetNodeId;
    const inputNodeArr = [];
    const outputNode = nodes.find(item => item.id === outputNodeId);
    inputNodeIdArr?.forEach(inputId => {
      inputNodeArr.push(nodes.find(item => item.id === inputId));
    });
    firstRunAddNodeToPreview({ sourceNode: inputNodeArr, outputNode });
  };

  return { firstRunAddNodeToPreview, firstRunAllAddNodeToPreview };
};

export default useRunEdgeAddNodeToPreview;
